'use strict';
import get from 'lodash/get';
import {mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {buildInjector} from '../../../_libs/angular-utils';
import {isWebView} from '../../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {fileIsImage} from '../../../files/domain/FileDomain';
import {FileFulfillmentPendingItemView} from './FileFulfillmentPendingItemView';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'PersistentUploaderService',
]);

// Limit image sized parsed based on build environment. 10MB in a browser. 2MB on mobile.
const MAX_PREVIEW_SIZE = (isWebView() ? 10 : 2) * 1024 * 1024;

export const StreamedComponent = (props$) => {
  const PersistentUploaderService = dependencies.PersistentUploaderService;
  const file$ = props$
    .map(props => props.model)
    .distinctUntilChanged(null, model => get(model, 'key'));

  const isImage$ = file$.map(fileIsImage);

  const preview$ = file$
    .switchMap(model => {
      const key = model.key;

      if (!fileIsImage(model)) {
        return Observable.of({
          showPreview: false,
          url: null,
        });

      } else if (window.FileReader && model.size < MAX_PREVIEW_SIZE) {
        return PersistentUploaderService.getReadAsDataURL$(key)
          .map(fileData => ({
            showPreview: true,
            previewLoading: false,
            url: fileData.url,
          }))
          .catch(() => Observable.of({
            showPreview: false,
            previewLoading: true,
            url: null,
          }))
          .startWith({
            showPreview: true,
            previewLoading: true,
            url: null,
          });

      } else {
        return Observable.of({
          showPreview: false,
          previewLoading: false,
          url: null,
        });
      }
    });

  const progress$ = getProgress$(file$);

  // TODO: onClick needs to pass the current preview data, if any

  return props$
    .combineLatest(
      isImage$,
      preview$,
      progress$,
      (props, isImage, preview, progress) => ({
        ...props,
        ...preview,
        ...progress,
        isImage,
      }));
};

export const FileFulfillmentPendingItemContainer = mapPropsStream(StreamedComponent)(FileFulfillmentPendingItemView);

FileFulfillmentPendingItemContainer.messages = FileFulfillmentPendingItemView.messages;
FileFulfillmentPendingItemContainer.messageProps = FileFulfillmentPendingItemView.messageProps;

function getProgress$(file$) {
  const PersistentUploaderService = dependencies.PersistentUploaderService;
  return file$
    .switchMap(file => {
      const promise = PersistentUploaderService.getUploadProgressObservable(file.key);
      if (promise) {
        return Observable
          .fromPromise(promise)
          .switchMap(progress$ => progress$)
          .map(progress => progress.lengthComputable ? {
            progress: (progress.loaded / progress.total) * 100,
            isIndefinite: false,
          } : {
            progress: null,
            isIndefinite: true,
          });
      } else {
        return Observable.of({
          progress: null,
          isIndefinite: true,
        });
      }
    })
    .catch(() => Observable.of({
      progress: null,
      isIndefinite: true,
    }))
    .startWith({
      progress: null,
      isIndefinite: true,
    });
}



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileFulfillmentPendingItem/FileFulfillmentPendingItemContainer.js